import { useCallback } from 'react';

import { useSession } from './useSession';

interface Options {
  firstName: string | null;
  lastName: string | null;
}

export const useUpdateSessionCustomer = () => {
  const [session, setSession] = useSession();

  return useCallback(
    (options: Options) => {
      if (!session) {
        throw new Error('Session is not set, cannot update customer fields');
      }

      setSession({
        ...session,
        customer: {
          ...session.customer,
          ...options
        }
      });
    },
    [session, setSession]
  );
};
